import { TableCell, TableRow } from '@material-ui/core'
import { useNavigate } from 'react-router-dom'

import { useNonprofitsData } from '../../Layout/nonprofitsContext/useNonprofitsData/useNonprofitsData'

import { Validation } from '@percent/admin-dashboard/api/types'
import { ReactComponent as DropdownSVG } from '@percent/admin-dashboard/common/assets/images/dropdown.svg'
import { TimeLeft } from '@percent/admin-dashboard/common/components'
import { CountryCodeFlag } from '@percent/admin-dashboard/common/components/countryCodeFlag/CountryCodeFlag'
import { getDate } from '@percent/admin-dashboard/common/utility/getDate'
import { handleClickAsLink } from '@percent/admin-dashboard/common/utility/handleClickAsLink'
import styles from './ValidationPendingRow.module.scss'

type ValidationPendingRowProps = {
  row: Validation
}

export function ValidationPendingRow({ row }: ValidationPendingRowProps) {
  const navigate = useNavigate()
  const { setValidation } = useNonprofitsData()

  const validationRowClick = (validation: Validation) => {
    setValidation(validation)

    return handleClickAsLink(`/validations/${validation.id}`, navigate)
  }

  return (
    <TableRow key={row.id} onClick={validationRowClick(row)} className={styles.row}>
      <TableCell>
        <CountryCodeFlag countryCode={row.countryCode} />
      </TableCell>
      <TableCell>{row.name}</TableCell>
      <TableCell>{row.partner.name ?? ''}</TableCell>
      <TableCell align="right" className={styles.rowNoWrap} style={{ padding: '16px 50px 16px 0', textAlign: 'left' }}>
        {getDate(row.createdAt)}
      </TableCell>
      <TableCell align="right" className={styles.rowNoWrap} style={{ padding: '16px 50px 16px 0', textAlign: 'left' }}>
        <TimeLeft requestedDate={row.createdAt} />
      </TableCell>
      <TableCell align="right" className={styles.rowIconForward} style={{ padding: '0' }}>
        <DropdownSVG className={styles.arrow} />
      </TableCell>
    </TableRow>
  )
}
